/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Alert/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChairFilled from 'DesignSystem/Svgs/Tysiav2ChairFilled/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Alert({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Alerts/Content/Content/Alerts/Alert"
  
}) {
let alertItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'alert_item',
path: 'isFirst',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let alertResourcesValueData = fromData.useDataFormat({ viewPath,
context: 'alert',
path: 'resources',
format: fromHelpers.getResourceList,
})
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let alertValueData = fromData.useDataFormat({ viewPath,
context: 'alert',
format: fromFormat.formatTimegridAppointmentTime,
})
let dtColorsGreen800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.800'
        })
let alertContentValueData = fromData.useDataValue({ viewPath,
context: 'alert',
path: 'content',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let alertCreatedByValueData = fromData.useDataValue({ viewPath,
context: 'alert',
path: 'created_by',
})
let alertSysCreatedValueData = fromData.useDataValue({ viewPath,
context: 'alert',
path: 'sys_created',
})
let tabSelectedTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.time_zone_id',
})
let aggregateData = fromHelpers.getCreatedBy(alertCreatedByValueData, alertSysCreatedValueData, tabSelectedTimeZoneIdValueData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Alert.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-4z5bt': dtColorsNeutral200,'--pb-4-4z5bt': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btw-2-4z5bt': alertItemIsFirstValueData ? "0px" : "1px",'--pt-3-4z5bt': alertItemIsFirstValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Alert.Vertical"
  data-view-path={viewPath}
 style={{'--g-5-4z5bt': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Alert.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-4z5bt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2ChairFilled
  viewPath={`${viewPath}/Tysiav2ChairFilled`}
 fill2={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="alert.resources"
 format="helpers.js getResourceList"
 text={alertResourcesValueData}
 weight="semibold"
/>
<div
  data-testid="Alert.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-6-4z5bt': dtColorsGreen200,'--pl-7-4z5bt': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pr-8-4z5bt': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--h-9-4z5bt': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsGreen800}
 size="tiny"
 data="alert"
 format="/Data/format.js formatTimegridAppointmentTime"
 text={alertValueData}
/>
</div>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 data="alert.content"
 text={alertContentValueData}
 color={dtColorsNeutral900}
/>
<div
  data-testid="Alert.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-10-4z5bt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft="auto"
 size="tiny"
 color={dtColorsNeutral600}
 data="alert.created_by"
 data="alert.sys_created"
 data="tab.selected.time_zone_id"
 aggregate="helpers.js getCreatedBy"
 text={aggregateData}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}